module.exports = __webpack_public_path__ + "img/wax-seal.be68b35e.png";